export default "__VITE_ASSET__Bq14rohM__"